<div class="notification-item" [@slideClose]>
  <aw-swipe-row
    [label]="notificationTitle() || translations.title"
    [rowKey]="notification().id"
    [actions]="swipeActions()"
    [disabled]="!appService.onlineStatus() || pending()"
    [dividers]="false"
    (opened)="showActions.set($event)"
    (actionSelected)="onSwipeAction($event)"
  >
    <div class="notification-card-frame" [class.notification-card-frame--grouped]="groupCollapsible()">
      <button type="button" class="notification-card" [disabled]="pending()" (click)="notificationClicked($event)">
        <aw-notification-content [notification]="notification()" />
      </button>
      @if (groupCollapsible()) {
        <!-- A sibling of the card because buttons cannot be nested. -->
        <aw-icon-button
          class="conversation-toggle"
          [style]="'subtle'"
          [icon]="groupExpanded() ? 'chevron-down' : 'chevron-right'"
          [ariaLabel]="commonTranslations.toggleExpanded"
          [pressed]="groupExpanded()"
          (touchstart)="onTogglePressStart($event)"
          (mousedown)="onTogglePressStart($event)"
          (click)="groupToggled.emit()"
        />
      }
    </div>
  </aw-swipe-row>
</div>
